import React from 'react';
//import { Bar } from 'react-chartjs-2';
import { Table } from 'react-bootstrap';
import { getValidationTable, getValidationTable_lvl2 } from '../components/UserFunctions'
//import { getValidationMetrics } from '../components/UserFunctions'
import PropTypes from 'prop-types';

export default class App extends React.Component {
  state = {
    stats_tp: [],
    stats_fp: [],
    stats_fn: [],
    metrics: [],
    number_runs: []
  }
  componentDidMount() {
    console.log(this.props)
    if (this.props.level === "3" ){
      getValidationTable().then(res => {
        if (res !== undefined) {
          // console.log(res.data);
          this.setState({
            stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
            stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
            stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
       
            metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
          })
        }
      })
    }
    else{
      const param_json = { run_lim:this.props.run_lim, bench_id:"empty" }
      if(this.props.run_lim==="5"){
        this.setState({
          number_runs:"Last 5 "
        })
      }
      else{
        this.setState({
          number_runs:"All "
        })
      }
      getValidationTable_lvl2(param_json).then(res => {
        if (res !== undefined) {
          // console.log(res.data);
          this.setState({
            stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
            stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
            stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
   
            metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
          })
        }
      })
    }
      

  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ( this.props.level==="3" && newProps.run_id !== this.props.run_id ) {
      var runid_json = { run_id: newProps.run_id }
      getValidationTable(runid_json).then(res => {
        // console.log(res.data.data);
        this.setState({
          stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
          stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
          stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
          
          metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
        })
      })
    }
    if (this.props.level==="2" && newProps.bench_id !== this.props.bench_id) {
      var benchid_json = { bench_id: newProps.bench_id, run_lim:newProps.run_lim }

      if(newProps.run_lim==="5"){
        this.setState({
          number_runs:"Last 5 "
        })
      }
      else{
        this.setState({
          number_runs:"All "
        })
      }
      getValidationTable_lvl2(benchid_json).then(res => {
        // console.log(res.data.data);
        this.setState({
          stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
          stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
          stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
     
          metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
        })
      })
    } 
  }

  // UNSAFE_componentWillReceiveProps(newProps) {
  //   if ( this.props.level==="3" && newProps.run_id !== this.props.run_id ) {
  //     var runid_json = { run_id: newProps.run_id }
  //     getValidationTable(runid_json).then(res => {
  //       // console.log(res.data.data);
  //       this.setState({
  //         stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
  //         stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
  //         stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
          
  //         metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
  //       })
  //     })
  //   }
  //   if (this.props.level==="2" && newProps.bench_id !== this.props.bench_id) {
  //     var benchid_json = { bench_id: newProps.bench_id, run_lim:newProps.run_lim }

  //     if(newProps.run_lim==="5"){
  //       this.setState({
  //         number_runs:"Last 5 "
  //       })
  //     }
  //     else{
  //       this.setState({
  //         number_runs:"All "
  //       })
  //     }
  //     getValidationTable_lvl2(benchid_json).then(res => {
  //       // console.log(res.data.data);
  //       this.setState({
  //         stats_tp: [res.data.run_stats.tp[0], res.data.run_stats.tp[1], res.data.run_stats.tp[2], res.data.run_stats.tp[3]],
  //         stats_fp: [res.data.run_stats.fp[0], res.data.run_stats.fp[1], res.data.run_stats.fp[2], res.data.run_stats.fp[3]],
  //         stats_fn: [res.data.run_stats.fn[0], res.data.run_stats.fn[1], res.data.run_stats.fn[2], res.data.run_stats.fn[3]],
     
  //         metrics: [res.data.metrics[0], res.data.metrics[1], res.data.metrics[2]]
  //       })
  //     })
  //   } 
  // }

  render() {
    return (
      <div data-test = 'dashboardTableComponent' style={{ paddingTop: 10 }}>
        <div className="row">
          <div className="col-lg-6" style={{ paddingTop: 3 }}>
            <div className='ibox'>
              <div className="ibox-head">
                <div className="ibox-title">
                  <font color="white">&nbsp;{this.state.number_runs} Run Statistics(Total Objects : {this.state.stats_tp[0] + this.state.stats_fp[0] + this.state.stats_fn[0]})</font>

                </div>
              </div>
              <div className="ibox-body">

                {this.state.stats_tp !== undefined ?
                  <Table striped hover>
                    <thead style={{ borderBottom: "4px solid #622AD8", backgroundColor: "#757AF7" }}>
                      <tr>
                        <th><font color="white" >Type</font></th>
                        <th><font color="white" >Count</font></th>
                        <th><font color="white" >Percentage</font></th>
                        <th style={{ display: "none" }}><font color="white" id="value">Min</font></th>
                        <th style={{ display: "none" }}><font color="white" id="value">Max</font></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">TP</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_tp[0]}</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_tp[1]} %</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_tp[2]}</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_tp[3]}</font></td>
                      </tr>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">FP</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_fp[0]}</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_fp[1]} %</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_fp[2]}</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_fp[3]}</font></td>
                      </tr>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">FN</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_fn[0]}</font></td>
                        <td><font color="#464646" id="value">{this.state.stats_fn[1]} %</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_fn[2]}</font></td>
                        <td style={{ display: "none" }} id="value"><font color="#464646">{this.state.stats_fn[3]}</font></td>
                      </tr>

                    </tbody>
                  </Table>
                  : <div className="alert alert-secondary" role="alert">
                    No data available
                    </div>
                }
              </div>
            </div>
          </div>
          <div className="col-lg-6" style={{ paddingTop: 3 }}>
            <div className='ibox'>

              <div className="ibox-head">
                <div className="ibox-title">
                  <font color="white">&nbsp;{this.state.number_runs} Run Metrics</font>

                </div>
              </div>
              <div className="ibox-body">
                {this.state.metrics !== undefined ?
                  <Table striped hover>
                    <thead style={{ borderBottom: "4px solid #622AD8", backgroundColor: "#757AF7" }}>
                      <tr>
                        <th><font color="white" >Metric</font></th>
                        <th><font color="white" >Value</font></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">Precision</font></td>
                        <td><font color="#464646" id="value">{this.state.metrics[0]} %</font></td>

                      </tr>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">Recall</font></td>
                        <td><font color="#464646" id="value">{this.state.metrics[1]} %</font></td>

                      </tr>
                      <tr style={{ backgroundColor: "white" }}>
                        <td><font color="#464646" id="value">F1-Score</font></td>
                        <td><font color="#464646" id="value">{this.state.metrics[2]} %</font></td>

                      </tr>

                    </tbody>
                  </Table>
                  : <div className="alert alert-secondary" role="alert">
                    No data available
                       </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>



    );
  }
}
// App.propTypes={
//   level:PropTypes.string,
//   run_id:PropTypes.number,
//   bench_id:PropTypes.number,
//   run_lim:PropTypes.string,
//   //navigateHome:PropTypes.string,
//   }
//   App.defaultProps= {
//   level:[],
//   run_id:1,
//   bench_id:1,
//   run_lim:[],
//   //navigateHome:[],
//   }

App.propTypes={
level:PropTypes.string,
run_id:PropTypes.number,
bench_id:PropTypes.number,
run_lim:PropTypes.string,
//navigateHome:PropTypes.string,
}
App.defaultProps= {
level:[],
run_id:1,
bench_id:1,
run_lim:[],
//navigateHome:[],
}
